import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const PersonIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 14">
      <path d="M10.8 14C10.8 14 12 14 12 12.8333C12 11.6667 10.8 8.16667 6 8.16667C1.2 8.16667 0 11.6667 0 12.8333C0 14 1.2 14 1.2 14H10.8ZM6 7C5.04522 7 4.12955 6.63125 3.45441 5.97487C2.77928 5.3185 2.4 4.42826 2.4 3.5C2.4 2.57174 2.77928 1.6815 3.45441 1.02513C4.12955 0.368749 5.04522 0 6 0C6.95478 0 7.87045 0.368749 8.54558 1.02513C9.22072 1.6815 9.6 2.57174 9.6 3.5C9.6 4.42826 9.22072 5.3185 8.54558 5.97487C7.87045 6.63125 6.95478 7 6 7Z" />
    </SvgIcon>
  );
};

export default PersonIcon;
